export interface Page {
  link: PageSlug | string;
  modal?: boolean;
  label: string;
  class?: string;
}

export enum PageSlug {
  Home = '',
  Dialog = 'd',
  StaticPages = 'pages',
  StaticPageSlug = 'pageSlug',
  Services = 'services',
  ServiceId = 'serviceId',
  Offers = 'offers',
  Blog = 'blogs',
  BlogId = 'blogId',
  About = 'about-us',
  ContactUs = 'contact',
  Terms = 'terms',
  PrivacyPolicy = 'privacy-policy',
}

